import React from 'react';
import { Box, Typography } from '@mui/material';
import { Check as CheckIcon } from '@mui/icons-material';

const STEPS = ['Select', 'Analyze', 'Review', 'Enhance', 'Save'];

interface StepperBarProps {
   currentStep: number;
}

const StepperBar: React.FC<StepperBarProps> = ({ currentStep }) => {
   return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 3, px: 1 }}>
         {STEPS.map((label, i) => {
            const stepNum = i + 1;
            const isCompleted = stepNum < currentStep;
            const isCurrent = stepNum === currentStep;

            return (
               <React.Fragment key={label}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5, flex: 0 }}>
                     <Box sx={{
                        width: 28,
                        height: 28,
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '12px',
                        fontWeight: 600,
                        transition: 'all 0.3s ease',
                        background: isCompleted || isCurrent ? '#1D9E75' : '#253530',
                        color: isCompleted || isCurrent ? '#FFFFFF' : '#546E7A',
                        border: isCurrent ? '2px solid rgba(29,158,117,0.5)' : '2px solid transparent',
                     }}>
                        {isCompleted ? <CheckIcon sx={{ fontSize: 16 }} /> : stepNum}
                     </Box>
                     <Typography sx={{
                        fontSize: '10px',
                        fontWeight: isCurrent ? 600 : 400,
                        color: isCompleted || isCurrent ? '#FFFFFF' : '#546E7A',
                        whiteSpace: 'nowrap',
                     }}>
                        {label}
                     </Typography>
                  </Box>
                  {i < STEPS.length - 1 && (
                     <Box sx={{
                        flex: 1,
                        height: 2,
                        mx: 0.5,
                        mt: -2,
                        transition: 'background 0.3s ease',
                        background: isCompleted ? '#1D9E75' : '#253530',
                        borderRadius: 1,
                     }} />
                  )}
               </React.Fragment>
            );
         })}
      </Box>
   );
};

export default StepperBar;
